import React from 'react';
import PropTypes from 'prop-types';
import './Billboard.css';


// import ReactTransitionGroup from 'react-addons-transition-group'
// import TransitionGroup from 'react-transition-group/TransitionGroup'

class Billboard extends React.Component {
  static propTypes = {
      children: PropTypes.node,
  };

  render() {
      const { children } = this.props;
      return (
          <div className="billboard">
              <div className="message"><span className="message-text">{children}</span></div>

              <div className="line left" />
              <div className="line right" />
          </div>
      );
  }
}

export default Billboard;



// WEBPACK FOOTER //
// ./src/components/billboard/Billboard.js